import styled from "styled-components"

export const ToggleShowDiv = styled.div`
    display: ${({show}) => show ? "block" : "none"};
`